var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"resize-icon",attrs:{"viewBox":"0 0 15 15","width":_vm.size,"height":_vm.size}},[_c('path',{attrs:{"d":"M10.9 0H15v4.1h-1V1.8L9.7 6.1l-.8-.8L13.2 1h-2.3zM5.3 8.9l.8.8L1.8 14h2.3v1H0v-4.1h1v2.3z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }